import Vue from "vue";
import Vuex from "vuex";

import wahrhouseModule from "./modules/warhouses.js";

Vue.use(Vuex);

export default new Vuex.Store({
    state() {
        return {
            open: false,
            loading: false,
            active_status: "",
            countryW: localStorage.getItem("countryW") || null,
            user: {},
            sous_warehouses: [],
            update: false,
            pr_version: 1,
            model: "",
        };
    },
    mutations: {
        actionSidebar(state) {
            state.open = !state.open;
        },
        actionloadingpage: function (state, payload) {
            state.loading = payload.loading;
        },
        actionSatus(state) {
            state.active_status = "";
        },
        actionCountry: function (state, payload) {
            state.countryW = payload.countryW;
        },
        actionSousWarehouses: function (state, payload) {
            state.sous_warehouses = payload.sous_warehouses;
        },
        actionSeller: function (state, payload) {
            state.user = payload.user;
        },
        actionupdate: function (state, payload) {
            state.update = payload.update;
            if (payload.pr_version) state.pr_version = payload.pr_version;
        },
        modelupdate: function (state, payload) {
            state.model = payload.model;
        },
    },
    actions: {
        actionSidebar(context) {
            context.commit("actionSidebar");
        },
        actionloadingpage(context, payload) {
            context.commit("actionloadingpage", payload);
        },
        actionSatus(context) {
            context.commit("actionSatus");
        },
        actionCountry(context, payload) {
            context.commit("actionCountry", payload);
        },
        actionSeller(context, payload) {
            context.commit("actionSeller", payload);
        },
        actionSousWarehouses(context, payload) {
            context.commit("actionSousWarehouses", payload);
        },
        actionupdate(context, payload) {
            context.commit("actionupdate", payload);
        },
        modelupdate(context, payload) {
            context.commit("modelupdate", payload);
        },
    },
    getters: {
        ShowSidebar(state) {
            return state.open;
        },
        loadingpage(state) {
            return state.loading;
        },
        getStatus(state) {
            return state.active_status;
        },
        resize() {
            if (window.innerWidth < 960) return true;
            else return false;
        },
    },

    modules: {
        wharhouse: wahrhouseModule,
    },
});
